import React, { HTMLAttributes } from "react"
import { cn } from "~/lib/utils"

type LogoProps = HTMLAttributes<HTMLDivElement> & {
    variant?: "default" | "square"
}

const Logo: React.FC<LogoProps> = ({ variant = "default", className, ...props }) => {
    const src = variant === "square" ? "/logo-square.svg" : "/logo.svg"

    return (
        <div className={cn("flex items-center justify-center", className)} {...props}>
            <img src={src} alt="Atécé" />
        </div>
    )
}

export { Logo }
